exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1, h2 {\n  color: #fff;\n}\n.filtres label {\n  color: #fff;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/devis/devis.component.css
// module id = ../../../../../src/app/_components/devis/devis.component.css
// module chunks = main